module.exports = __webpack_public_path__ + "static/img/ls40.b3c998f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls40.png
// module id = LE00
// module chunks = 12